import { useEffect, useRef } from "react";

const GlowCard = ({ children, identifier }) => {
  const containerRef = useRef(null);
  const cardRefs = useRef([]);

  useEffect(() => {
    const CONTAINER = containerRef.current;
    const CARDS = cardRefs.current;

    const CONFIG = {
      proximity: 40,
      spread: 80,
      blur: 12,
      gap: 32,
      vertical: false,
      opacity: 0,
    };

    const UPDATE = (event) => {
      for (const CARD of CARDS) {
        const CARD_BOUNDS = CARD.getBoundingClientRect();

        if (
          event?.x > CARD_BOUNDS.left - CONFIG.proximity &&
          event?.x < CARD_BOUNDS.left + CARD_BOUNDS.width + CONFIG.proximity &&
          event?.y > CARD_BOUNDS.top - CONFIG.proximity &&
          event?.y < CARD_BOUNDS.top + CARD_BOUNDS.height + CONFIG.proximity
        ) {
          CARD.style.setProperty("--active", 1);
        } else {
          CARD.style.setProperty("--active", CONFIG.opacity);
        }

        const CARD_CENTER = [
          CARD_BOUNDS.left + CARD_BOUNDS.width * 0.5,
          CARD_BOUNDS.top + CARD_BOUNDS.height * 0.5,
        ];

        let ANGLE =
          (Math.atan2(event?.y - CARD_CENTER[1], event?.x - CARD_CENTER[0]) *
            180) /
          Math.PI;

        ANGLE = ANGLE < 0 ? ANGLE + 360 : ANGLE;

        CARD.style.setProperty("--start", ANGLE + 90);
      }
    };

    document.body.addEventListener("pointermove", UPDATE);

    const RESTYLE = () => {
      if (CONTAINER) {
        CONTAINER.style.setProperty("--gap", CONFIG.gap);
        CONTAINER.style.setProperty("--blur", CONFIG.blur);
        CONTAINER.style.setProperty("--spread", CONFIG.spread);
        CONTAINER.style.setProperty(
          "--direction",
          CONFIG.vertical ? "column" : "row"
        );
      }
    };

    RESTYLE();
    UPDATE();

    // Cleanup event listener
    return () => {
      document.body.removeEventListener("pointermove", UPDATE);
    };
  }, [identifier]);

  return (
    <div ref={containerRef} className="glow-container flex flex-col">
      <article
        ref={(el) => {
          if (el && !cardRefs.current.includes(el)) {
            cardRefs.current.push(el);
          }
        }}
        className="glow-card relative h-fit cursor-pointer transition-all duration-300 bg-[#101123] text-gray-200 rounded-xl hover:border-transparent w-full"
      >
        <div className="glows absolute inset-0 pointer-events-none"></div>
        {children}
      </article>
    </div>
  );
};

export default GlowCard;
